import type { AssessmentResponseValue } from '../../types/assessment.types';

const RESPONSE_OPTIONS: { label: string; value: AssessmentResponseValue }[] = [
  { label: 'Usually', value: 'always' },
  { label: 'Sometimes', value: 'sometimes' },
  { label: 'Not yet', value: 'not_yet' },
];

interface AssessmentQuestionCardProps {
  /** Question number (1-based) for display */
  questionNumber: number;
  /** Question text */
  text: string;
  /** Currently selected response, or null if unanswered */
  selectedResponse: AssessmentResponseValue | null;
  /** Called when user selects a response */
  onSelect: (response: AssessmentResponseValue) => void;
  /** Whether response is currently being saved */
  isSaving?: boolean;
}

export default function AssessmentQuestionCard({
  questionNumber,
  text,
  selectedResponse,
  onSelect,
  isSaving = false,
}: AssessmentQuestionCardProps) {
  return (
    <div className="flex flex-col gap-4">
      {/* Question text */}
      <div className="py-2">
        <p className="text-lg font-bold text-[#007CAD] tracking-[-0.72px] leading-tight">
          {questionNumber}. {text}
        </p>
      </div>

      {/* Option buttons */}
      <div className="flex flex-col gap-2">
        {RESPONSE_OPTIONS.map((option) => {
          const isSelected = selectedResponse === option.value;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onSelect(option.value)}
              disabled={isSaving}
              className={`
                w-full h-12 px-6 rounded-lg border-2 text-left
                text-lg font-bold tracking-[-0.72px]
                transition-all duration-150
                disabled:opacity-70
                ${isSelected
                  ? 'border-[#01A7C8] bg-[#DBF7F8] text-[#1B2831]'
                  : 'border-[#C7EDEF] bg-white text-[#1B2831] hover:border-[#01A7C8]'
                }
              `}
              aria-pressed={isSelected}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
